exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".feedback .input-group.input-group--selection-controls label{left:25px;font-size:13px}", "", {"version":3,"sources":["/home/circleci/repo/src/components/modal/feedbackModal.vue"],"names":[],"mappings":"AACA,6DACE,UAAW,AACX,cAAgB,CACjB","file":"feedbackModal.vue","sourcesContent":["\n.feedback .input-group.input-group--selection-controls label {\n  left: 25px;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ddbabd12","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modal/feedbackModal.vue
// module id = 951
// module chunks = 13 16 19 20 21 22